export default __webpack_public_path__ + "public/assets/images/85bea75ebd50c9440b4f7b3bc3baddcb.jpg";